import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
import { NavLink } from "react-router-dom";
import { useReactToPrint } from "react-to-print";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  formatPrice,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { MdDelete } from 'react-icons/md';

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastError, ToastSuccess } from "../../../../../functions/ToastShow";
import Moment from "react-moment";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import  { UserContext } from "../../../../../contexts/User"
import DataTable from "../../../../common/DataTable";
import RawClosingStockPrint from "./RawClosingStockPrint";

const ClosingStockHistory = () => {
  const { t } = useTranslation();
  //getting context values here
  let {
    //common
    loading,
    setLoading,
  } = useContext(SettingsContext);
  const { authUserInfo } = useContext(UserContext)

  let {
    //purchase order
    getPaginatedClosingStock,
    setClosingStockList,
    setClosingStockListForSearch,
    closingStockListForSearch,
    closingStockList,
    
    //pagination
    dataPaginating,
    setDataPaginating
  } = useContext(RestaurantContext);

  //search result
  const [searchedClosingStock, setSearchedClosingStock] = useState({
    list: null,
    searched: false,
  });

  const searchRef = useRef(null);
  //useEffect == componentDidMount
  useEffect(() => {
    getPaginatedClosingStock(1)
  }, []);
  //search purchase order here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchedClosingStock({ ...searchedClosingStock, searched: false });
    } else {
      let searchedList = closingStockListForSearch.filter((item) => {
        //branch
        let lowerCaseBranch = item.branch_name.toLowerCase();
        //email
        let lowerCaseItemInvoice = item.document_identity !== null && item.document_identity.toLowerCase();

        return (
          lowerCaseItemInvoice.includes(searchInput) ||
          lowerCaseBranch.includes(searchInput)
        );
      });
      setSearchedClosingStock({
        ...searchedClosingStock,
        list: searchedList,
        searched: true,
      });
    }
  };

  const handleFetchData = (page) => {
    getPaginatedClosingStock(page);
  };

  const getListData = useCallback(() => {
    if (searchedClosingStock.searched) {
      return searchedClosingStock.list;
    }
    return closingStockList?.data || [];
  }, [searchedClosingStock, closingStockList]);

  const onClearSearch = () => {
    setSearchedClosingStock({ ...searchedClosingStock, searched: false });
    if (searchRef.current) {
      searchRef.current.value = "";
    }
  }

  //delete confirmation modal of purchase order
  const handleDeleteConfirmation = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleDeletePurchase(id);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  //delete purchase here
  const handleDeletePurchase = (id) => {
    setDataPaginating(true);
    const url = BASE_URL + `/settings/closing-stock/${id}`;
    return axios
      .delete(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setClosingStockList(res.data[0]);
        setClosingStockListForSearch(res.data[1]);
        setSearchedClosingStock({
          ...searchedClosingStock,
          list: res.data[1],
        });
        setDataPaginating(false);
        ToastSuccess({ title: `${_t(t("Closing Stock has been deleted"))}` });
      }).catch(() => {
        setDataPaginating(false);
        ToastError({ title: `${_t(t("Please try again"))}` });
      });
  };

  //print bills states and function
  const [newRow, setNewRow] = useState([]);
  let [branch, setBranch] = useState('');

  const componentRef = useRef();

  const handleOnlyPrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: "@page { margin: 15px }"
  });

  const handleGetPrintData = async (item) => {
    const url = BASE_URL + "/settings/closing-stock-report";
    setDataPaginating(true);
    const formData ={
      branch_id: item.branch?.id,
      document_date: item.document_date
    }
    try {
      const res = await axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
      if (res.data) {
        const branch = item.branch.name;
        setBranch(branch)
        setNewRow([...res.data.data]);
        setDataPaginating(false)
        setTimeout(() => {
          handleOnlyPrint();
        }, 0);
      }
    } catch (error) {
      setDataPaginating(false)
      console.log("error==>", error)
      ToastError({ title: `${_t(t("Please try again"))}` });
    }
  }

   //post button function
   const handlePostApi = async (item) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/closing-stock-mark-post"
    let formData = new FormData();
    formData.append('id',item.id)
    formData.append('is_post', item.is_post ? 0 : 1)
    try {
      const res = await axios.post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
        if(res.data){
          setClosingStockList(res.data[0]);
          setClosingStockListForSearch(res.data[1]);
          setSearchedClosingStock({
            ...searchedClosingStock,
            list: res.data[1],
          });
          setDataPaginating(false);
          ToastSuccess({title: item?.is_post ? "Purchase Invoice has been unpost" : "Purchase Invoice has been post"})
        }
        setDataPaginating(false);
    } catch(err) {
      setDataPaginating(false);
      if(err.response?.data?.status === "error"){
        ToastError({ title: `${_t(t(err.response.data.message))}` });
        return
      }
      ToastError({ title: `${_t(t("Please try again"))}` });
    }
  }

  //unpost confirmation modal
  const handleUnPostConfirmation = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body px-5">
            <h3>{_t(t("Are you sure?"))}</h3>
            <p className="text-center">{_t(t("You want to un post this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handlePostApi(item);
                  onClose();
                }}
              >
                {_t(t("Yes, unpost it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const COLUMNS = [
    { label: "S/L", render: (item, i) => i + 1 },
    { label: "Invoice #", key: "document_identity" },
    { label: "Date", render: (item) => <Moment format="LL">{item.document_date}</Moment> },
    { label: "Branch", render: (item) => <>{item.branch?.name}</>  },
    { label: "Remarks", key: "remarks" },
    {
      label: "Action", render: (item) => (
        <div className="d-flex justify-content-center">
          <button
            className="btn btn-secondary ml-2 rounded-sm del-btn"
            onClick={() => handleGetPrintData(item)}
          >
            <i className="fa fa-print edit-icon"></i>
          </button>
          {
            item.is_post !== 1 ? <>
              <NavLink
                title="Edit"
                className="btn btn-primary ml-2 rounded-sm"
                to={`/dashboard/manage/stock/closing-stock-edit/${item.id}`}
                style={{ height: "1.7rem", width: "1.7rem" }}
              >
                <div className="d-flex align-items-center justify-content-center">
                  <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
                </div>
              </NavLink>
              <button
                title="Delete"
                className="btn btn-danger ml-2 rounded-sm del-btn"
                onClick={() => handleDeleteConfirmation(item.id)}
              >
                <MdDelete className="del-icon" />
              </button>
              <button
                className="btn btn-dark ml-2 rounded-sm del-btn"
                title="Post PI" 
                style={{padding:"1px 0px 0px 1px"}} 
                disabled={loading}                                              
                onClick={()=>handlePostApi(item)}
              >
                <i className="fa fa-check-square-o" aria-hidden="true"></i>
              </button>
            </> : ""
          }
          <NavLink
            title="duplicate closing"
            to={`/dashboard/manage/stock/closing-stock-edit/${item.id}?duplicate=1`}
            className="btn btn-success ml-2 rounded-sm del-btn"
          >
            <i className="fa fa-clone"></i>  
          </NavLink>
          {authUserInfo?.details?.user_type === "superAdmin" && item.is_post === 1 ? (<button
              className="btn btn-warning ml-2 rounded-sm del-btn"
              title="Unpost PI" 
              style={{padding:"1px 0px 0px 1px"}} 
              disabled={loading}                                              
              onClick={()=>handleUnPostConfirmation(item)}
            >
              <i className="fa fa-check-square-o" aria-hidden="true"></i>
            </button>) : null
          }
        </div>
      )
    }
  ];

  return (
    <>
      <Helmet>
        <title>{_t(t("Closing Stock"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className=" row mx-3 gx-2 align-items-center t-pt-15 t-pb-15">
                  <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                    <ul className="t-list fk-breadcrumb">
                      <li className="fk-breadcrumb__list">
                        <span className="t-link fk-breadcrumb__link text-capitalize">
                          {!searchedClosingStock.searched
                            ? _t(t("Closing Stock List"))
                            : _t(t("Search Result"))}
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6 col-lg-7">
                    <div className="row gx-3 align-items-center">
                      {/* Search customer */}
                      <div className="col-md-9 t-mb-15 mb-md-0">
                        <div className="input-group">
                          <div className="form-file">
                            <input
                              ref={searchRef}
                              type="text"
                              className="form-control border-0 form-control--light-1 rounded-left"
                              placeholder={_t(t("Search")) + ".."}
                              onChange={handleSearch}
                              disabled={loading || dataPaginating}
                            />
                          </div>
                          <button
                            className="btn btn-primary rounded-right"
                            type="button"
                          >
                            <i
                              className="fa fa-search"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </div>
                      </div>

                      {/* Add customer modal trigger button */}
                      <div className="col-md-3 text-md-right">
                        <NavLink
                          to="/dashboard/manage/stock/closing-stock-add"
                          className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                        >
                          {_t(t("add new"))}
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <DataTable
                loading={loading || dataPaginating}
                data={getListData()}
                columns={COLUMNS}
                emptyText="No data available"
                pagination={{
                  isPageLoading: loading,
                  isPagination: true,
                  pageCount: closingStockList?.last_page,
                  currentPage: closingStockList?.current_page,
                  from: closingStockList?.from,
                  to: closingStockList?.to,
                  total: closingStockList?.total,
                }}
                handleFetchData={handleFetchData}
                searchPayload={{
                  isSearched: searchedClosingStock.searched,
                  onClearSearch
                }}


              />
            </div>
            {/* Rightbar contents end*/}
          </div>

        </div>
      </main>
      {/* main body ends */}
      <RawClosingStockPrint
        name="Raw Material"
        closingStockData={newRow}
        branch={branch}
        closingStockRef={componentRef}
      />
    </>
  )
}

export default ClosingStockHistory
